<template>
  <div class="user-claim-credits-box">
    <h2 id="claim-credit-methods">
      {{ $t("components.user.claim_credits_box.amount_to_claim_title") }}
    </h2>
    <div class="d-flex flex-column flex-lg-row">
      <div class="d-flex flex-column flex-fill">
        <p class="h5">{{ $t("components.user.claim_credits_box.current_balance") }}</p>
        <p class="h3">{{ user.balance | currency }}</p>
      </div>
      <div class="d-flex flex-column flex-fill">
        <p class="h5 mb-n1">{{ $t("components.user.claim_credits_box.amount_to_claim") }}</p>
        <AmountSelect
          v-model="selectedAmount"
          add-standard-options
          :actual-cost="Number(user.balance)"
          actual-cost-label="Total"
          :maximum="Number(user.balance)"
          :value="0"
          :minimum-required="10"
        />
      </div>
      <div class="d-flex flex-column flex-fill">
        <p class="h5">{{ $t("components.user.claim_credits_box.remaining_balance") }}</p>
        <p class="h3">{{ calculateAmount() | currency }}</p>
      </div>
    </div>

    <b-alert variant="info" show>
      {{ $t("components.user.claim_credits_box.claim_amount_note") }}
    </b-alert>

    <bank-details-form
      :save-button-label="$t('components.user.claim_credits_box.buttons.request_transfer')"
      save-button-icon="arrow-right-circle"
      show-cancel
      :show-reset="false"
      :show-loading="loading"
      @cancel="emitCancel"
      @saved="claimCredit"
    />
  </div>
</template>

<script>
import BankDetailsForm from "@/components/PaymentMethod/BankDetailsForm.vue";
import AmountSelect from "@/components/Forms/AmountSelect.vue";

export default {
  name: "UserClaimCreditsBox",
  components: { AmountSelect, BankDetailsForm },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      selectedAmount: 0,
    };
  },
  methods: {
    emitCancel() {
      this.$emit("cancel");
    },
    async claimCredit() {
      this.loading = true;

      try {
        await this.$store.dispatch("account/claimCredit", { selected_amount: this.selectedAmount });
      } catch (e) {
        this.loading = false;
        return;
      }

      this.$emit("claimed");

      this.$store.commit("addNotification", {
        content: this.$t("components.user.claim_credits_box.notifications.request_sent.message"),
        title: this.$t("components.user.claim_credits_box.notifications.request_sent.title"),
        variant: "success",
        type: "balance_claim",
      });

      this.loading = false;
    },
    calculateAmount() {
      let userAmount = this.user.balance;
      let reclaimAmount = this.selectedAmount;

      return userAmount - reclaimAmount;
    },
  },
};
</script>

<style lang="scss"></style>
